export default "__VITE_ASSET__DIXkgAVE__"